
import { Link } from 'react-router-dom';

const RecentActivity = () => {
  const activities = [
    {
      id: '1',
      type: 'project_update',
      title: 'Project Progress Updated',
      description: 'Sunset Villa Renovation progress updated to 65%',
      time: '2 hours ago',
      icon: 'ri-building-line',
      color: 'text-blue-600 bg-blue-100'
    },
    {
      id: '2',
      type: 'meeting',
      title: 'Meeting Scheduled',
      description: 'Site inspection scheduled for Downtown Office Complex',
      time: '4 hours ago',
      icon: 'ri-calendar-line',
      color: 'text-green-600 bg-green-100'
    },
    {
      id: '3',
      type: 'document',
      title: 'Document Uploaded',
      description: 'Blueprint v2.1 uploaded to Maple Street Apartments',
      time: '6 hours ago',
      icon: 'ri-file-upload-line',
      color: 'text-purple-600 bg-purple-100'
    },
    {
      id: '4',
      type: 'invoice',
      title: 'Invoice Generated',
      description: 'Invoice #INV-2024-001 created for Industrial Warehouse',
      time: '8 hours ago',
      icon: 'ri-bill-line',
      color: 'text-orange-600 bg-orange-100'
    },
    {
      id: '5',
      type: 'task',
      title: 'Task Completed',
      description: 'Security system installation completed',
      time: '1 day ago',
      icon: 'ri-checkbox-circle-line',
      color: 'text-green-600 bg-green-100'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">Recent Activity</h2>
          <Link 
            to="/activity"
            className="text-blue-600 hover:text-blue-700 text-sm font-medium whitespace-nowrap"
          >
            View All
          </Link>
        </div>
      </div>

      <div className="p-6">
        <div className="space-y-4">
          {activities.map((activity) => (
            <div
              key={activity.id}
              className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${activity.color}`}>
                <i className={`${activity.icon} text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900">{activity.title}</p>
                <p className="text-sm text-gray-600 mt-1">{activity.description}</p>
                <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
              </div>
            </div>
          ))}
        </div>

        {activities.length === 0 && (
          <div className="text-center py-8">
            <i className="ri-history-line text-4xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">No recent activity</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;
